import { User, AuthState } from './store'
import { RequestState } from '../../../modules/types'
import { Partner } from '../../partner/store/store'

export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_RECEIVED = 'LOGIN_RECEIVED'
export const LOGIN_ERROR = 'LOGIN_ERROR'
export const LOGIN_INVALID = 'LOGIN_INVALID'
export const LOGOUT = 'LOGOUT'
export const REMOVE_USER_DATA = 'REMOVE_USER_DATA'
export const SELECT_PARTNER = 'SELECT_PARTNER'

export type AuthAction =
  | { type: typeof LOGIN_REQUEST }
  | { type: typeof LOGIN_RECEIVED, user: User, partners: Partner[], isPapertrailEmployee: boolean }
  | { type: typeof LOGIN_ERROR }
  | { type: typeof LOGIN_INVALID }
  | { type: typeof LOGOUT }
  | { type: typeof REMOVE_USER_DATA }

export function authReducer(state: AuthState, action: AuthAction): AuthState {
  switch (action.type) {
    case LOGIN_REQUEST: {
      return {
        ...state,
        requestState: RequestState.Loading,
        partners: []
      }
    }

    case LOGIN_RECEIVED: {
      return {
        ...state,
        requestState: RequestState.Loaded,
        error: undefined,
        user: action.user,
        partners: action.partners,
        isPapertrailEmployee: action.isPapertrailEmployee
      }
    }

    case LOGIN_ERROR: {
      return {
        ...state,
        requestState: RequestState.Error,
        error: "login_error"
      }
    }

    case LOGIN_INVALID: {
      return {
        ...state,
        requestState: RequestState.Error,
        error: "invalid_usertype",
        isPapertrailEmployee: undefined
      }
    }

    case LOGOUT: {
      return {
        ...state,
        requestState: RequestState.NotLoaded,
        error: undefined,
        partners: [],
        isPapertrailEmployee: undefined
      }
    }

    case REMOVE_USER_DATA: {
      return {
        ...state,
        user: undefined
      }
    }

    default: {
      return state
    }
  }
}
